document.addEventListener('DOMContentLoaded', function(){ 

  
  // Mobile layout. Show product sizes by clicking on Product item

  let deviceWidth = window.innerWidth;
  if(deviceWidth < 961) {
    let prodItemsLink = document.querySelectorAll('.card-wrapper .media');
    prodItemsLink.forEach(function(prodItemLink) {
      prodItemLink.addEventListener('click', function() {
        
        let prodItem = prodItemLink.closest('.product-card');
        let sizesBlock = prodItem.querySelector('.products-sizes');
        let secondImage = prodItem.querySelector('.media--second');
        
        if(!prodItem.classList.contains('active')) {
                                                 
          prodItemsLink.forEach(function(prodItemLink2) {
            let prodItem2 = prodItemLink2.closest('.product-card');
            prodItem2.classList.remove('active');
          });

          if(sizesBlock || secondImage) {
            prodItem.classList.add('active');
          }

        }
        
      });
    });
  }
});
